import * as React from "react";
import * as _ from "lodash";
import { Utilities } from "../../shared/utilities";
import { IAppReducerAction, IEnvironment } from "../shared/model";


export const getEnvironments = (dispatch: React.Dispatch<IAppReducerAction>) => {
    const fetchEnvironments = async () => {
        try {
            const environments: IEnvironment[] = await Utilities.getFetch("api/environment/details");
            dispatch({ type: "SET_ENVIRONMENTS", environments: environments });
        } catch (e) {
            Utilities.toastError(e);
            console.error(e);
        }
    };
    fetchEnvironments();
};

export function setIsLoading(dispatch: React.Dispatch<IAppReducerAction>, isLoading: boolean) {
    dispatch({ type: "SET_ISLOADING", isLoading: isLoading });
}
